"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const grapesjs_1 = __importDefault(require("grapesjs"));
// @ts-expect-error FIXME: Property 'plugins' does not exist on type 'typeof grapesjs'
exports.default = grapesjs_1.default.plugins.add('gjs-plugin-s3', (editor, opts = {}) => {
    const c = opts;
    const config = editor.getConfig();
    // @ts-expect-error FIXME: Property 'stylePrefix' does not exist on type 'EditorConfig'.
    const pfx = (config === null || config === void 0 ? void 0 : config.stylePrefix) || '';
    let btnEl;
    const defaults = {
        btnEl: '',
        btnText: 'Add images',
        imgFormats: [],
        bucketName: '',
        prefix: ''
    };
    // Load defaults
    for (const name in defaults) {
        if (!(name in c)) {
            // @ts-expect-error cannot index on name
            c[name] = defaults[name];
        }
    }
    if (!c.imgFormats) {
        c.imgFormats = ['png', 'jpeg', 'jpg'];
    }
    const loader = document.createElement('div');
    loader.id = 'cover-spin';
    document.body.append(loader);
    function showLoader() {
        loader.style.display = 'block';
    }
    function hideLoader() {
        loader.style.display = 'none';
    }
    const uploadToS3 = (file) => {
        showLoader();
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'uploadAsset' does not exist on type '{}'.
        c.uploadAsset(file);
        hideLoader();
        // remove broken instance of image block so new asset can be added correctly
        editor.UndoManager.undo();
    };
    // When the Asset Manager modal is opened
    // @ts-expect-error FIXME: Property 'uploadComplete' does not exist on type '{}'.
    editor.on('run:open-assets', () => {
        let inputEl;
        const modal = editor.Modal;
        // @ts-expect-error FIXME: Property 'getContentEl' does not exist on type 'Modal'.
        const modalBody = modal.getContentEl();
        const uploader = modalBody.querySelector('.' + pfx + 'am-file-uploader');
        const assetsHeader = modalBody.querySelector('.' + pfx + 'am-assets-header');
        const assetsBody = modalBody.querySelector('.' + pfx + 'am-assets-cont');
        uploader && (uploader.style.display = 'none'); // eslint-disable-line no-unused-expressions
        assetsHeader && (assetsHeader.style.display = 'none'); // eslint-disable-line no-unused-expressions
        assetsBody.style.width = '100%';
        // Instance button if not yet exists
        if (!btnEl) {
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'btnEl' does not exist on type '{}'.
            btnEl = c.btnEl;
            if (!btnEl) {
                btnEl = document.createElement('button');
                btnEl.className = pfx + 'btn-prim ' + pfx + 'btn-s3';
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'btnText' does not exist on type '{}'.
                btnEl.innerHTML = c.btnText;
                inputEl = document.createElement('INPUT');
                inputEl.setAttribute('type', 'file');
                inputEl.style.display = 'none';
                inputEl.onchange = (e) => {
                    var _a;
                    const file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
                    uploadToS3(file);
                };
                document.body.appendChild(inputEl);
            }
            btnEl.onclick = () => {
                inputEl.click();
            };
        }
        assetsBody.insertBefore(btnEl, assetsHeader);
    });
});
